import React from 'react';
import PropTypes from 'prop-types';

import './styles.css';

const NoEventsMask = props => {
  const { relative = false } = props;

  return (
    <div
      className={`no-events-mask${relative ? ' no-events-mask--relative' : ''}`}
    ></div>
  );
};

NoEventsMask.propTypes = {
  relative: PropTypes.bool,
};

export default NoEventsMask;
